import { gql } from 'Utils/apolloClient'

const installmentChangeOwedQuery = gql`
  query InstallmentChangeOwed($installmentId: ID!, $paymentCashAmount: Float, $slug: String!) {
    campground(slug: $slug) {
      id
      isCountryUs
      installment(id: $installmentId) {
        id
        camperChangeOwed(paymentCashAmount: $paymentCashAmount) {
          amount
          display
        }
      }
    }
  }`

export default installmentChangeOwedQuery
